import { render, staticRenderFns } from "./MenuAzioni.vue?vue&type=template&id=07cf0db6&scoped=true&"
import script from "./MenuAzioni.vue?vue&type=script&lang=js&"
export * from "./MenuAzioni.vue?vue&type=script&lang=js&"
import style0 from "./MenuAzioni.vue?vue&type=style&index=0&id=07cf0db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cf0db6",
  null
  
)

export default component.exports